export function roundUp(number) {
    if (number === "") {
        return ""
    }
    return Math.ceil(number);
}